// Separate wellness video visibility control: play when visible, pause when hidden
document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.wellness');
  if (!section) return;

  var container = section.querySelector('.wellness-image-mobile') || section;
  var videoCircle = container.querySelector('.wellness-video-circle');
  if (!videoCircle) return;

  function getVideoEl() {
    return videoCircle ? videoCircle.querySelector('video') : null;
  }
  function ensureSourceAndPlay() {
    var vid = getVideoEl();
    if (!vid) return;
    if (!vid.src) {
      var desiredSrc = vid.getAttribute('data-src') || 'https://cdn.shopify.com/videos/c/o/v/721cd58a1ad7421691099cdb040842a3.mp4';
      vid.src = desiredSrc;
      try { vid.load(); } catch (e) {}
    }
    try { vid.play().catch(function () {}); } catch (e) {}
  }
  function pauseVideo() {
    var vid = getVideoEl();
    if (!vid) return;
    try { vid.pause(); } catch (e) {}
  }

  // Prefer IntersectionObserver
  if ('IntersectionObserver' in window) {
    try {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0) {
            ensureSourceAndPlay();
          } else {
            pauseVideo();
          }
        });
      }, { threshold: [0, 0.01] });
      io.observe(videoCircle);
      return;
    } catch (e) {}
  }

  // Fallback: GSAP ScrollTrigger
  if (typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.create({
      trigger: videoCircle,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: ensureSourceAndPlay,
      onEnterBack: ensureSourceAndPlay,
      onLeave: pauseVideo,
      onLeaveBack: pauseVideo
    });
    return;
  }

  // Last fallback: manual scroll/resize visibility checks
  function isVisible(el) {
    var rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }
  function onScrollTick() {
    if (isVisible(videoCircle)) {
      ensureSourceAndPlay();
    } else {
      pauseVideo();
    }
  }
  window.addEventListener('scroll', onScrollTick, { passive: true });
  window.addEventListener('resize', onScrollTick);
  onScrollTick();
});

// document.addEventListener('DOMContentLoaded', function () {
//   var videoCircle = document.querySelector('.wellness .wellness-video-circle');
//   if (!videoCircle) return;

//   var video = videoCircle.querySelector('video');
//   if (!video) return;

//   // Функція вставки відео
//   function loadVideo() {
//     if (!video.src) {
//       video.src = video.getAttribute('data-src') ||
//         'https://cdn.shopify.com/videos/c/o/v/68ca3cb82095423a9406487ecad614f8.webm';
//       try { video.load(); video.play().catch(()=>{}); } catch(e){}
//     }
//   }

//   // Легкий IntersectionObserver
//   var io = new IntersectionObserver(function (entries) {
//     if (entries[0].isIntersecting) {
//       loadVideo();
//     }
//   }, { threshold: 0.1 });

//   io.observe(videoCircle);
// });